<template>
  <div class="tags-view">
    <div class="tags-scroll">
      <span
        v-for="(tab, i) in visited"
        :key="tab.fullPath"
        class="tag"
        :class="{ active: isActive(tab) }"
        @click="go(tab)"
      >
        <span class="tag-dot" v-if="isActive(tab)"></span>
        <span class="tag-title">{{ tab.title }}</span>
        <span
          v-if="!tab.affix"
          class="tag-close"
          @click.stop="close(tab, i)"
        >×</span>
      </span>
    </div>

    <span class="tags-split"></span>

    <el-dropdown class="tags-more" trigger="click" @command="handleCommand">
      <span class="more-btn">
        <i class="el-icon-arrow-down"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="refresh" icon="el-icon-refresh-right">刷新当前</el-dropdown-item>
        <el-dropdown-item command="closeOthers" icon="el-icon-close">关闭其他</el-dropdown-item>
        <el-dropdown-item command="closeAll" icon="el-icon-folder-delete">关闭全部</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { generateTitle } from '@/utils/i18n'

export default {
  name: 'TagsView',
  data() {
    return {
      visited: []
    }
  },
  watch: {
    $route() {
      this.addTab(this.$route)
    }
  },
  mounted() {
    this.addTab(this.$route)
  },
  methods: {
    generateTitle,
    getTitle(route) {
      const matched = route.matched.filter(r => r.meta && r.meta.title)
      if (matched.length) {
        return this.generateTitle(matched[matched.length - 1].meta.title)
      }
      if (route.path === '/Welcome' || route.path === '') return '工作台'
      return route.name || route.path
    },
    isActive(tab) {
      return this.$route.fullPath === tab.fullPath
    },
    addTab(route) {
      const fullPath = route.fullPath
      if (this.visited.some(t => t.fullPath === fullPath)) return
      this.visited.push({
        fullPath,
        path: route.path,
        title: this.getTitle(route),
        affix: route.path === '/Welcome'
      })
    },
    go(tab) {
      if (this.isActive(tab)) return
      this.$router.push(tab.fullPath)
    },
    close(tab, index) {
      const next = this.visited[index + 1] || this.visited[index - 1] || null
      this.visited = this.visited.filter(t => t !== tab)
      if (this.isActive(tab)) {
        if (next) this.$router.push(next.fullPath)
        else this.$router.push('/Welcome')
      }
    },
    closeOthers() {
      const active = this.visited.find(t => t.fullPath === this.$route.fullPath)
      this.visited = this.visited.filter(t => t.affix || t === active)
    },
    closeAll() {
      const affix = this.visited.filter(t => t.affix)
      this.visited = affix
      if (!affix.some(t => t.fullPath === this.$route.fullPath)) {
        this.$router.push((affix[0] && affix[0].fullPath) || '/Welcome')
      }
    },
    refresh() {
      this.$router.go(0)
    },
    handleCommand(command) {
      if (command === 'refresh') this.refresh()
      else if (command === 'closeOthers') this.closeOthers()
      else if (command === 'closeAll') this.closeAll()
    }
  }
}
</script>

<style lang="less" scoped>
.tags-view {
  display: flex;
  align-items: center;
  height: 48px;
  background: #fff;
  border-radius: 12px;
  padding: 0 6px 0 10px;
  box-shadow: 0 4px 16px rgba(20, 40, 60, 0.06);
  border: 1px solid rgba(20, 40, 60, 0.05);
  margin-bottom: 12px;

  .tags-scroll {
    flex: 1;
    display: flex;
    align-items: center;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    height: 100%;

    &::-webkit-scrollbar {
      height: 0;
      width: 0;
    }
  }

  .tag {
    position: relative;
    display: inline-flex;
    align-items: center;
    height: 32px;
    padding: 0 10px;
    margin-right: 8px;
    border-radius: 8px;
    font-size: 13px;
    line-height: 1;
    color: #5a6b74;
    background: #f4f7f9;
    border: 1px solid #e8edf1;
    cursor: pointer;
    transition: all 0.2s ease;
    user-select: none;

    &:first-child {
      margin-left: 2px;
    }
    &:hover {
      background: #eef3f6;
      color: #0a2230;
      border-color: #d9e2e8;
    }
    &.active {
      color: #04222b;
      font-weight: 600;
      background: linear-gradient(135deg, #00e5ff, #00ffa3);
      border-color: transparent;
      box-shadow: 0 4px 12px rgba(0, 229, 255, 0.32);
    }

    .tag-dot {
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background: #04222b;
      margin-right: 7px;
      flex-shrink: 0;
    }
    .tag-title {
      line-height: 1;
    }
    .tag-close {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 0;
      height: 16px;
      margin-left: 0;
      border-radius: 50%;
      font-size: 13px;
      line-height: 1;
      overflow: hidden;
      opacity: 0;
      transform: scale(0.6);
      transition: all 0.2s ease;
    }

    &:hover .tag-close,
    &.active .tag-close {
      width: 16px;
      margin-left: 6px;
      opacity: 1;
      transform: scale(1);
    }
    .tag-close:hover {
      background: rgba(4, 34, 43, 0.18);
    }
    &:not(.active) .tag-close:hover {
      background: rgba(0, 0, 0, 0.1);
    }
  }

  .tags-split {
    flex-shrink: 0;
    width: 1px;
    height: 20px;
    margin: 0 4px 0 6px;
    background: #e6ecf0;
  }

  .tags-more {
    flex-shrink: 0;

    .more-btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
      border-radius: 8px;
      color: #5a6b74;
      cursor: pointer;
      transition: all 0.2s ease;

      &:hover {
        background: #eef3f6;
        color: #00c2d6;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TagsView.vue